import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styled';

const Loader = ({ size }) => (
  <S.LoaderContainer>
    <S.CustomSpinner animation="border" variant="primary" size={size} />
  </S.LoaderContainer>
);

Loader.propTypes = {
  size: PropTypes.string,
};

Loader.defaultProps = {
  size: 'lg',
};

export default Loader;
